import React from 'react';
import { useAppSelector } from '../hooks/redux';

const Debug: React.FC = () => {
  const auth = useAppSelector((state) => state.auth);
  const routes = useAppSelector((state) => state.routes);

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold mb-4">Debug Information</h1>
      
      <div className="space-y-4">
        <div>
          <h2 className="text-lg font-semibold">Auth State:</h2>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
            {JSON.stringify(auth, null, 2)}
          </pre>
        </div>
        
        <div>
          <h2 className="text-lg font-semibold">Routes State:</h2>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
            {JSON.stringify(routes, null, 2)}
          </pre>
        </div>
        
        <div>
          <h2 className="text-lg font-semibold">Local Storage:</h2>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
            {JSON.stringify({
              access_token: localStorage.getItem('access_token'),
              refresh_token: localStorage.getItem('refresh_token'),
            }, null, 2)}
          </pre>
        </div>
        
        <div>
          <h2 className="text-lg font-semibold">Current URL:</h2>
          <p className="bg-gray-100 p-3 rounded text-sm">
            {window.location.href}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Debug;
